class CurlearStickyAddToCart extends HTMLElement {
  connectedCallback() {
    this.targetButton = document.getElementById(this.dataset.targetButton);
    this.priceSource = document.getElementById(this.dataset.priceSource);
    this.button = this.querySelector('[data-sticky-atc-button]');
    this.priceEl = this.querySelector('[data-sticky-atc-price]');

    if (this.button && this.targetButton) {
      this.button.addEventListener('click', () => this.targetButton.click());
      this.syncAvailability();
      this.availabilityObserver = new MutationObserver(() => this.syncAvailability());
      this.availabilityObserver.observe(this.targetButton, {
        attributes: true,
        attributeFilter: ['disabled'],
        childList: true,
        characterData: true,
        subtree: true,
      });
    }

    if (!this.targetButton || !('IntersectionObserver' in window)) return;

    this.observer = new IntersectionObserver(
      (entries) => {
        const targetVisible = entries[0].isIntersecting;
        this.classList.toggle('curlear-sticky-atc--visible', !targetVisible);
        if (!targetVisible) this.syncPrice();
      },
      { threshold: 0 }
    );
    this.observer.observe(this.targetButton);
  }

  syncAvailability() {
    if (!this.button || !this.targetButton) return;
    const soldOut = this.targetButton.disabled;
    this.button.disabled = soldOut;
    this.button.textContent = this.targetButton.textContent.trim();
  }

  syncPrice() {
    if (!this.priceSource || !this.priceEl) return;
    const priceWrapper = this.priceSource.querySelector('.price');
    if (!priceWrapper) return;
    const selector = priceWrapper.classList.contains('price--on-sale')
      ? '.price__sale .price-item--sale'
      : '.price__regular .price-item--regular';
    const priceItem = priceWrapper.querySelector(selector);
    if (priceItem) this.priceEl.textContent = priceItem.textContent.trim();
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
    if (this.availabilityObserver) this.availabilityObserver.disconnect();
  }
}

customElements.define('curlear-sticky-add-to-cart', CurlearStickyAddToCart);
